import {gql, useApolloClient} from '@apollo/client';
import {useCallback} from 'react';
import {SubmittedRequestType as RequestType} from "../../submitted-request/SubmittedRequestDomain";
import {ValidationResult} from "../../domain";

import {
    CHECK_SUBMITTED_REQUESTS,
    CheckSubmittedRequestsResponse,
    submittedRequestValidationMessage
} from "../../submitted-request/SubmittedRequestOpenCaseQuery";


function validateResponse(data: CheckSubmittedRequestsResponse): ValidationResult {
    if (!data) {
        return {status: false, message: 'Error! No data returned from server'};
    }

    if (data.openCaseSubmitRequestQuery.length > 0) {
        const first = data.openCaseSubmitRequestQuery[0];
        const requestType = RequestType[first.requestType as keyof typeof RequestType];
        return {
            status: false,
            message: submittedRequestValidationMessage(RequestType.Client_Return_Transfer_Request, requestType, first.caseNumber)
        };
    }

    return {status: true, message: 'Pass!'};
}

export const useClientTransferValidation = () => {
    const client = useApolloClient();
    const validateClientTransfer = useCallback(async (authorizationGuid?: string): Promise<ValidationResult> => {
        if (!authorizationGuid) {
            return {status: true, message: 'No authorizationGuid'};
        }
        return client.query<CheckSubmittedRequestsResponse>({
            query: CHECK_SUBMITTED_REQUESTS,
            variables: {
                authorizationGuid: authorizationGuid,
                requestTypes: ["Treatment_Hold", "No_Contact", "Client_Return_Transfer_Request"]
            },
            fetchPolicy: 'network-only',
        }).then(({data}) => validateResponse(data));
    }, [client]);

    return {validateClientTransfer};
};
